import { StaticNode } from '../type';
import { staticNodes } from './nodes';

export function requestStaticNodesMock(): Promise<Array<StaticNode>> {
  return Promise.resolve(staticNodes);
}
